<!-- /**
* 工队详情页面
* @authors zzt
* @date 2019/1/28
* @version 1.0
*/ -->
<template>
  <div class="talents">
    <div class="talents_details">
      <Breadcrumb :breadcrumbName="breadcrumbObj"></Breadcrumb>
      <div class="talents_details_content">
        <div class="talents_details_content_left">
          <!-- 个体 -->
          <div
            v-if="messageData.isCompany == 0"
            class="talents_details_content_left_titleBox"
          >
            <div class="left_box">
              <div class="title">
                <div class="text">{{ messageData.teamName }}</div>
                <div class="title-icon">
                  <span v-if="messageData.teamStatus === 1">可出工</span>
                  <span v-if="messageData.teamStatus === 0">不可出</span>
                  <span>个体</span>
                </div>
              </div>
              <div class="item">
                <span style="marginRight:20px">
                  联系人：{{ messageData.contact }}
                </span>
                <span>
                  联系电话：
                  <span v-if="showpNumber">{{ messageData.phoneNumber }}</span>
                  <span v-else>{{ ShowPhone(messageData.phoneNumber) }}</span>
                  <span
                    class="showText"
                    v-if="!showpNumber"
                    @click="ShowPhoneNumber"
                  >
                    查看完整号码
                  </span>
                </span>
              </div>
              <div class="item">
                <div>
                  <span>团队规模：</span>
                  <span>{{ messageData.teamSize }}</span>
                </div>
                <div>
                  <span>所在地区：</span>
                  <span>
                    {{ messageData.provinceName }}
                    {{
                      messageData.cityName ? "/" + messageData.cityName : null
                    }}
                  </span>
                  <span
                    @click="showMap"
                    style="marginLeft:20px;cursor:pointer;"
                    v-if="messageData.longitude && messageData.latitude"
                  >
                    <img src="@/assets/public/map.jpg" alt />
                  </span>
                </div>
              </div>
              <div class="item">
                <div class="flex-item">
                  <div style="width:90px">主营业务：</div>
                  <div>{{ ChangeStringBus(messageData) }}</div>
                  <!-- <span>{{messageData.firstCategoryName}}{{messageData.secondCategoryName?'/'+messageData.secondCategoryName:null}}{{messageData.thirdCategoryName?'/'+messageData.thirdCategoryName:null}}</span> -->
                </div>
              </div>
              <div class="itemBottom">
                <div class="left">
                  <div>
                    <span>服务地区：</span>
                    <span>{{ ChangeAddress(messageData.serviceArea) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="right_box">
              <div class="attention-wrap">
                <span
                  @click="clickAttention(true)"
                  v-if="!isAttention"
                  class="attention-item"
                >
                  <img
                    src="../../../assets/attention0.png"
                    height="14"
                    width="15"
                  />
                  <span>关注</span>
                </span>
                <span
                  @click="clickAttention(false)"
                  v-else
                  class="attention-item"
                >
                  <img
                    src="../../../assets/attention1.png"
                    height="14"
                    width="16"
                  />
                  <span>已关注</span>
                </span>
                <span class="show" v-show="messageData.createTime">
                  发布时间： {{ messageData.createTime | formatDate }}
                </span>
              </div>
              <div class="imgIcon">
                <img src="@/assets/redesignImg/person.png" alt />
                <img src="@/assets/redesignImg/phone.png" alt />
              </div>
              <div class="isgeti">
                <div class="Inquirys" @click="inByLetDialogClick">函询</div>
                <div class="zixun" @click="OnlineConsulting">
                  <img src="@/assets/redesignImg/msg.png" alt />
                  在线咨询
                </div>
              </div>
            </div>
          </div>
          <!-- 企业 -->
          <div
            v-else-if="messageData.isCompany == 1"
            class="talents_details_content_left_titleBox"
          >
            <div class="left_box">
              <div class="title">
                <div class="text">{{ messageData.teamName }}</div>
                <div class="title-icon">
                  <span v-if="messageData.teamStatus === 1">可出工</span>
                  <span v-if="messageData.teamStatus === 0">不可出</span>
                  <span>企业</span>
                </div>
              </div>
              <div class="item">
                <span style="marginRight:20px">
                  联系人：{{ messageData.contact }}
                </span>
                <span>
                  联系电话：
                  <span v-if="showpNumber">{{ messageData.phoneNumber }}</span>
                  <span v-else>{{ ShowPhone(messageData.phoneNumber) }}</span>
                  <span
                    class="showText"
                    v-if="!showpNumber"
                    @click="ShowPhoneNumber"
                  >
                    查看完整号码
                  </span>
                </span>
              </div>
              <div class="item">
                <div>
                  <span>团队规模：</span>
                  <span>{{ messageData.teamSize }}</span>
                </div>
                <div>
                  <span>所在地区：</span>
                  <span>
                    {{ messageData.provinceName
                    }}{{
                      messageData.cityName ? "/" + messageData.cityName : null
                    }}
                  </span>
                  <span
                    @click="showMap"
                    style="marginLeft:20px;cursor:pointer;"
                    v-if="messageData.longitude && messageData.latitude"
                  >
                    <img src="@/assets/public/map.jpg" alt />
                  </span>
                </div>
              </div>
              <div class="item">
                <div class="flex-item">
                  <div style="width:90px">主营业务：</div>
                  <div>{{ ChangeStringBus(messageData) }}</div>
                </div>
              </div>
              <div class="itemBottom">
                <div class="left">
                  <div>
                    <span>服务地区：</span>
                    <span>{{ ChangeAddress(messageData.serviceArea) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="right_box">
              <div class="attention-wrap">
                <span
                  @click="clickAttention(true)"
                  v-if="!isAttention"
                  class="attention-item"
                >
                  <img
                    src="../../../assets/attention0.png"
                    height="14"
                    width="15"
                  />
                  <span>关注</span>
                </span>
                <span
                  @click="clickAttention(false)"
                  v-else
                  class="attention-item"
                >
                  <img
                    src="../../../assets/attention1.png"
                    height="14"
                    width="16"
                  />
                  <span>已关注</span>
                </span>
                <span class="show" v-show="messageData.createTime">
                  发布时间： {{ messageData.createTime | formatDate }}
                </span>
              </div>
              <div class="imgIcon">
                <img src="@/assets/redesignImg/person.png" alt />
                <img src="@/assets/redesignImg/phone.png" alt />
                <img src="@/assets/redesignImg/ern.png" alt />
                <img src="@/assets/redesignImg/shophome.png" alt />
              </div>
              <div class="footer">
                <div class="textLeft" @click="enterpriseWeb">企业网站</div>
                <div class="Inquiry" @click="inByLetDialogClick">函询</div>
                <div class="box" @click="OnlineConsulting">
                  <img src="@/assets/redesignImg/msg.png" alt />
                  在线咨询
                </div>
              </div>
            </div>

            <!-- <div class="item">
              <div class="imgIcon">
                <img src="@/assets/redesignImg/person.png" alt />
                <img src="@/assets/redesignImg/phone.png" alt />
                <img src="@/assets/redesignImg/ern.png" alt />
                <img src="@/assets/redesignImg/shophome.png" alt />
              </div>
              <div class="footer">
                <div class="textLeft" @click="enterpriseWeb">企业网站</div>
                <div class="box" @click="OnlineConsulting">
                  <img src="@/assets/redesignImg/msg.png" alt />
                  在线咨询
                </div>
              </div>
            </div>-->
          </div>
          <!-- 游客 -->
          <div v-else class="talents_details_content_left_titleBox">
            <div class="left_box">
              <div class="title">
                <div class="text">{{ messageData.teamName }}</div>
                <div class="title-icon">
                  <span v-if="messageData.teamStatus === 1">可出工</span>
                  <span v-if="messageData.teamStatus === 0">不可出</span>
                  <!-- <span>企业</span> -->
                </div>
                <!-- <div class="show">浏览数：10000人</div> -->
                <!--              <div-->
                <!--                class="show"-->
                <!--                v-show="messageData.createTime"-->
                <!--              >发布时间： {{messageData.createTime | formatDate}}</div>-->
              </div>
              <div class="item">
                <span style="marginRight:20px">
                  联系人：{{ messageData.contact }}
                </span>
                <span>
                  联系电话：
                  <span v-if="showpNumber">{{ messageData.phoneNumber }}</span>
                  <span v-else>{{ ShowPhone(messageData.phoneNumber) }}</span>
                  <span
                    class="showText"
                    v-if="!showpNumber"
                    @click="ShowPhoneNumber"
                  >
                    查看完整号码
                  </span>
                </span>
              </div>
              <div class="item">
                <div>
                  <span>团队规模：</span>
                  <!-- <span> {{SizeData(messageData.teamSize)}}</span> -->
                  <span>{{ messageData.teamSize }}</span>
                </div>
                <div>
                  <span>所在地区：</span>
                  <span>
                    {{ messageData.provinceName
                    }}{{
                      messageData.cityName ? "/" + messageData.cityName : null
                    }}
                  </span>
                  <span
                    @click="showMap"
                    style="marginLeft:20px;cursor:pointer;"
                    v-if="messageData.longitude && messageData.latitude"
                  >
                    <img src="@/assets/public/map.jpg" alt />
                  </span>
                </div>
              </div>
              <div class="item">
                <div class="flex-item">
                  <div style="width:90px">主营业务：</div>
                  <div>{{ ChangeStringBus(messageData) }}</div>
                  <!-- <span>{{messageData.firstCategoryName}}{{messageData.secondCategoryName?'/'+messageData.secondCategoryName:null}}{{messageData.thirdCategoryName?'/'+messageData.thirdCategoryName:null}}</span> -->
                </div>
              </div>
              <div class="itemBottom">
                <div class="left">
                  <div>
                    <span>服务地区：</span>
                    <span>{{ ChangeAddress(messageData.serviceArea) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="right_box">
              <div class="attention-wrap">
                <span
                  @click="clickAttention(true)"
                  v-if="!isAttention"
                  class="attention-item"
                >
                  <img
                    src="../../../assets/attention0.png"
                    height="14"
                    width="15"
                  />
                  <span>关注</span>
                </span>
                <span
                  @click="clickAttention(false)"
                  v-else
                  class="attention-item"
                >
                  <img
                    src="../../../assets/attention1.png"
                    height="14"
                    width="16"
                  />
                  <span>已关注</span>
                </span>
                <span class="show" v-show="messageData.createTime">
                  发布时间： {{ messageData.createTime | formatDate }}
                </span>
              </div>
            </div>
          </div>
          <!-- <div
            v-else
            class="talents_details_content_left_titleBox"
          >
            <div
              v-if="messageData.teamStatus === 1"
              class="mark"
            >可出工</div>
            <div
              v-if="messageData.teamStatus === 0"
              class="unmark"
            >不可出</div>
            <div class="title">
              <div class="text">{{messageData.teamName}}</div>

            </div>
            <div class="item">
              <div>
                <span>联系人：</span>
                <span> {{messageData.teamSize}}</span>
              </div>
              <div>
                <span>联系电话：</span>
                <span v-if="showpNumber">
                  {{messageData.phoneNumber}}
                </span>
                <span v-else>
                  {{ShowPhone(messageData.phoneNumber)}}
                </span>

                <span
                  class="showText"
                  v-if="!showpNumber"
                  @click="ShowPhoneNumber"
                >查看完整号码</span>

              </div>
            </div>
            <div class="item">
              <div>
                <span>团队人数：</span>
                <span> {{SizeData(messageData.teamSize)}}</span>
              </div>
              <div>
                <span>主营业务：</span>
                <span>{{ChangeStringBus(messageData)}}</span>
             </div>
            </div>
            <div class="itemBottom">
              <div class="left">
                <div>
                  <span>所在地区：</span>
                  <span>{{messageData.provinceName}}{{messageData.cityName?'/'+messageData.cityName:null}}</span>
                </div>
              </div>
            </div>
          </div>-->
          <div>
            <div class="tab-box">
              <div class="inner">
                <div
                  id="tab"
                  v-for="(item, index) in tab"
                  :key="index"
                  :class="{ check: checkIndex == index }"
                  class="cursor"
                  @click="check(index)"
                  v-show="item.show"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div
              class="details-inner-box details-inner-bottom"
              ref="detailsInner1"
            >
              <div v-if="checkIndex == 0">
                <div class="p_info" v-if="true">
                  <!-- 施工报价-->
                  <!-- <LeaseList
                    isType="3"
                    :teamList="offerdataList"
                    :titleList="offerTitleList"
                    :loadingTrue="offerloadingTrue"
                    :noTextData="offernoTextData"
                  ></LeaseList>-->
                  <TeamTableList :teamList="offerdataList"></TeamTableList>
                  <!-- 分页 -->
                  <Pagination
                    :param="offerParam"
                    @change="offergetPage"
                    v-if="offerdataList.length != 0"
                    :loadingTrue="offerloadingTrue"
                  ></Pagination>
                </div>
                <div class="noData" v-else>
                  <div class="noDataImg">
                    <img src="@/static/img/cailiao.png" alt />
                  </div>
                  <p class="noText">暂无数据</p>
                </div>
              </div>
              <div v-show="checkIndex == 1">
                <div class="p_info Induce" v-if="true">
                  <div
                    ref="textShow"
                    class="text"
                    :class="[!ShowMoreText ? 'actionShow' : '']"
                  >
                    <span
                      style="white-space: pre-wrap;"
                      v-if="messageData.teamIntroduce"
                      v-html="messageData.teamIntroduce"
                    ></span>

                    <div class="noData" v-else>
                      <div class="noDataImg">
                        <img src="@/static/img/cailiao.png" alt />
                      </div>
                      <p class="noText">暂无数据</p>
                    </div>
                    <!-- <span v-else>
                      暂无简介
                    </span>-->
                  </div>
                  <div
                    class="optionShow"
                    v-show="isHtml && messageData.teamIntroduce"
                  >
                    <span
                      v-if="ShowMoreText"
                      class="showUp"
                      @click="ShowMoreText = false"
                    >
                      查看更多
                      <i class="el-icon-caret-bottom"></i>
                    </span>
                    <span v-else class="showDown" @click="ShowMoreText = true">
                      点击收起
                      <i class="el-icon-caret-top"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div v-if="checkIndex == 2">
                <div class="p_info" v-if="true">
                  <!-- 团队业绩 -->
                  <LeaseList
                    isType="0"
                    :teamList="dataList"
                    :titleList="performanceTitleList"
                    :loadingTrue="loadingTrue"
                    :noTextData="noTextData"
                  ></LeaseList>
                  <!-- 分页 -->
                  <Pagination
                    :param="performanceParam"
                    @change="getTeamperformance"
                    v-if="dataList.length != 0"
                    :loadingTrue="loadingTrue"
                  ></Pagination>
                </div>
                <div class="noData" v-else>
                  <div class="noDataImg">
                    <img src="@/static/img/cailiao.png" alt />
                  </div>
                  <p class="noText">暂无数据</p>
                </div>
              </div>
              <div v-if="checkIndex == 3">
                <div class="p_info" v-if="true">
                  <!-- 人员组成 -->
                  <LeaseList
                    isType="1"
                    :teamList="teamPersondataList"
                    :titleList="personTitleList"
                    :loadingTrue="loadingTruePerson"
                    :noTextData="noTextDataPerson"
                  ></LeaseList>
                  <!-- 分页 -->
                  <Pagination
                    :param="performanceParamPerson"
                    @change="getTeamPersonPage"
                    v-if="teamPersondataList.length != 0"
                    :loadingTrue="loadingTruePerson"
                  ></Pagination>
                </div>
                <div class="noData" v-else>
                  <div class="noDataImg">
                    <img src="@/static/img/cailiao.png" alt />
                  </div>
                  <p class="noText">暂无数据</p>
                </div>
              </div>
              <div v-if="checkIndex == 4">
                <div class="p_info" v-if="true">
                  <!-- 设备信息 -->
                  <LeaseList
                    isType="2"
                    :teamList="equTeamList"
                    :titleList="equTitleList"
                    :loadingTrue="equloadingTrue"
                    :noTextData="equnoTextData"
                  ></LeaseList>

                  <Pagination
                    :param="equParam"
                    @change="equgetTeam"
                    v-if="equTeamList.length != 0"
                    :loadingTrue="equloadingTrue"
                  ></Pagination>
                </div>
                <div class="noData" v-else>
                  <div class="noDataImg">
                    <img src="@/static/img/cailiao.png" alt />
                  </div>
                  <p class="noText">暂无数据</p>
                </div>
              </div>
              <div v-if="checkIndex == 5">
                <!-- 资质证书 -->
                <div class="p_info" v-if="this.CertList.length != 0">
                  <div class="itemListCert">
                    <div class="itemList">
                      <div
                        :class="[
                          'item',
                          item.picturePicData && item.picturePicData.length > 0
                            ? null
                            : 'NoData'
                        ]"
                        v-for="(item, index) in CertList"
                        :key="index"
                      >
                        <div
                          class="imgBox"
                          v-if="
                            item &&
                              item.picturePicData &&
                              item.picturePicData.length > 0
                          "
                        >
                          <el-image
                            style="width: 216px; height: 140px"
                            fit="cover"
                            :src="item.picturePicData[0]"
                            :key="index"
                            :preview-src-list="item.picturePicData"
                          >
                            <div
                              slot="placeholder"
                              class="image-slot"
                              style="textAlign: center;    background: #f5f7fa;height:140px;lineHeight: 140px;"
                            >
                              加载中
                              <span class="dot">...</span>
                            </div>
                          </el-image>
                          <div :class="['imgFooter']">
                            <div class="dele" @click="dele(item.id)">
                              <img src="@/assets/redesignImg/dele.png" alt />
                              <span>删除</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="itemList">
                      <div
                        :class="[
                          'item',
                          item.pictureVideoData ? null : 'NoData'
                        ]"
                        v-for="(item, index) in CertList"
                        :key="index"
                      >
                        <div
                          class="imgBoxVideo"
                          v-if="item && item.pictureVideoData"
                        >
                          <!-- style="width:460px;height:270px" -->
                          <video
                            :src="item.pictureVideoData"
                            class="avatar"
                            controls="controls"
                          >
                            您的浏览器不支持视频播放
                          </video>
                          <div :class="['imgFooter']">
                            <div class="dele" @click="dele(item.id)">
                              <img src="@/assets/redesignImg/dele.png" alt />
                              <span>删除</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="noData" v-else>
                  <div class="noDataImg">
                    <img src="@/static/img/cailiao.png" alt />
                  </div>
                  <p class="noText">暂无数据</p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="false">
            <div class="tab-box">
              <div class="inner">
                <div
                  id="tab"
                  v-for="(item, index) in Sectab"
                  :key="index"
                  :class="{ check: checkIndex == index }"
                  class="cursor"
                  @click="check(index)"
                  v-show="item.show"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div
              class="details-inner-box details-inner-bottom"
              ref="detailsInner1"
            >
              <div v-if="checkIndex == 0">
                <div class="p_info Sale" v-if="true"></div>
              </div>
              <div v-show="checkIndex == 1">
                <div class="p_info Induce" v-if="true">
                  <div
                    ref="textShow"
                    class="text"
                    :class="[!ShowMoreText ? 'actionShow' : '']"
                  >
                    <span>{{ messageData.teamIntroduce }}</span>
                  </div>
                  <div class="optionShow" v-show="isHtml">
                    <span
                      v-if="ShowMoreText"
                      class="showUp"
                      @click="ShowMoreText = false"
                    >
                      查看更多
                      <i class="el-icon-caret-bottom"></i>
                    </span>
                    <span v-else class="showDown" @click="ShowMoreText = true">
                      点击收起
                      <i class="el-icon-caret-top"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div v-if="checkIndex == 2">
                <div class="p_info" v-if="true">
                  <!-- 设备信息 -->
                  <LeaseList
                    isType="2"
                    :teamList="equTeamList"
                    :titleList="equTitleList"
                    :loadingTrue="equloadingTrue"
                    :noTextData="equnoTextData"
                  ></LeaseList>

                  <Pagination
                    :param="equParam"
                    @change="equgetTeam"
                    v-if="equTeamList.length != 0"
                    :loadingTrue="equloadingTrue"
                  ></Pagination>
                </div>
                <div class="noData" v-else>
                  <div class="noDataImg">
                    <img src="@/static/img/cailiao.png" alt />
                  </div>
                  <p class="noText">暂无数据</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dataList">
        <div class="title">
          <div class="name">相关团队推荐</div>
          <div class="more" @click="More">查看更多</div>
        </div>
        <div class="itemList" v-if="newSettledListData.length > 0">
          <div
            class="item"
            v-for="(item, index) in newSettledListData"
            :key="index"
          >
            <div class="top">
              <el-tooltip
                popper-class="changeTootip"
                effect="light"
                :visible-arrow="false"
                :content="item.teamName"
                placement="bottom"
                :offset="10"
              >
                <div
                  class="title"
                  style="color: #0286df !important;"
                  @click="GoDetila(item.no)"
                >
                  {{ item.teamName }}
                </div>
              </el-tooltip>
            </div>
            <div class="bottom">
              <div class="type">
                所在地区：
                <span>
                  {{ item.provinceName ? item.provinceName : null
                  }}{{ item.cityName ? "/" + item.cityName : null }}
                </span>
              </div>
              <div class="business">
                主营业务：
                <span>
                  <el-tooltip
                    popper-class="changeTootip"
                    effect="light"
                    :visible-arrow="false"
                    :content="ChangeStringRec(item)"
                    placement="bottom"
                    :offset="10"
                  >
                    <div style="display: inline">
                      {{ ChangeStringRec(item) }}
                    </div>
                  </el-tooltip>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="noList" v-else></div>
      </div>
    </div>

    <el-dialog
      center
      title="地图显示"
      :visible.sync="dialogFormVisible"
      width="70%"
      :close-on-click-modal="false"
    >
      <span>
        <i class="el-icon-location-outline"></i>
        所在地区:
        {{ messageData.provinceName }}
        {{ messageData.cityName ? "/" + messageData.cityName : null }}
      </span>
      <mapdetail
        ref="childDataDt"
        :center="mapCenter"
        :position="mapPosition"
        :text="text"
      ></mapdetail>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false">
          关 闭
        </el-button>
      </div>
    </el-dialog>
    <!-- 函询弹框 -->
    <InByLetDialog
      :dialogVisible="inByLetDialogShow"
      :dialogType="1"
      @closeDialog="closeinDialog"
      @cancelDialog="cancelDialog"
      @confirmDialog="confirminDialog"
    ></InByLetDialog>
  </div>
</template>

<script>
import axios from "@/http"
import { apiTalentsMess } from "@/api/apiTalentsMess"
import link from "@/public/link.js"
import { formatDate2, formatDate } from "@/filters"
import sessionStorage from "@/storage/sessionStorage"
import { apiResignAll } from "@/api/apiResignAll"
import localStorage from "@/storage/localStorage"
import apiHelp from "@/api/apiHelp"
import cookie from "@/storage/cookies"
const ERR_OK = 200

export default {
  name: "ConstructionDetails",
  props: {},
  data() {
    return {
      inByLetDialogShow: false,
      dialogFormVisible: false,
      mapCenter: [],
      mapPosition: [],
      teamSizeOption: [],
      userNo: "",
      companyNo: "",
      // markName:'',
      text: {
        text: "",
        offset: [0, -50]
      },

      ShowMoreText: true,
      isHtml: false,
      showpNumber: false,
      // 当前标志
      InfoNo: null,
      // 主题信息
      UserInfo: {},
      // 详情信息
      messageData: {
        besinessScope: "",
        contact: "",
        id: 3,
        no: "",
        phoneNumber: "",
        serviceArea: "",
        teamIntroduce: "",
        teamName: "",
        teamSize: 0,
        teamStatus: null,
        companyId: null,
        scopes: []
      },

      checkIndex: 0,
      phone: "",
      title: {
        name: "",
        updateTime: null
      },
      breadcrumbObj: {
        title: "当前位置：",
        fristName: "首页",
        fristPath: "/",
        secondName: "工队列表",
        secondPath: "/teamList",
        threeName: "工队详情"
      },
      Sectab: [
        {
          name: "施工报价",
          show: true
        },
        {
          name: "团队简介",
          show: true
        },

        {
          name: "自有设备",
          show: true
        }
      ],
      tab: [
        {
          name: "工种报价",
          show: true
        },
        {
          name: "工队简介",
          show: true
        },
        {
          name: "工队业绩",
          show: true
        },

        // {
        //   name: "资质证书",
        //   show: true
        // },
        {
          name: "工队人员",
          show: true
        },
        {
          name: "工队设备",
          show: true
        },
        {
          name: "工队相册",
          show: true
        }
      ],
      IsPerson: true,
      constructionTeamData: {},
      teamTypeData: [],
      teamSkillsData: [],
      rollScroll: false,
      // 视频相册
      CertList: [],
      VideoParam: {
        page: 1,
        limit: 10
      },

      // 施工报价
      offerdataList: [],
      offerTitleList: [
        "工程分类",
        "专业分类",
        "工程类型",
        "工种名称",
        "计量单位",
        "包含材料",
        "单价(元)",
        "包含设备",
        "报价单位"
      ],
      offerloadingTrue: false,
      offernoTextData: false,
      offerParam: {
        page: 1,
        limit: 10,
        companyNo: "",
        userNo: ""
      },
      // 团队业绩
      dataList: [],
      performanceTitleList: [
        "项目名称",
        "施工地点",
        "开工/竣工",
        "项目描述",
        "施工内容"
      ],
      loadingTrue: false,
      noTextData: false,
      performanceParam: {
        page: 1,
        limit: 10,
        companyNo: "",
        userNo: ""
      },
      // 人员组成
      teamPersondataList: [],
      personTitleList: ["姓名", "年龄(岁)", "工龄(年)", "联系电话", "简介"],
      loadingTruePerson: false,
      noTextDataPerson: false,
      performanceParamPerson: {
        page: 1,
        limit: 10,
        companyNo: "",
        userNo: ""
      },
      // 自由设备
      equTeamList: [],
      equTitleList: ["设备名称", "设备描述", "规格型号", "设备图片"],
      equloadingTrue: false,
      equnoTextData: false,
      equParam: {
        page: 1,
        limit: 10,
        companyNo: "",
        userNo: ""
      },
      CertloadingTrue: false,
      CertnoTextData: false,
      CertParam: {
        page: 1,
        limit: 10
      },
      newSettledListData: [],
      // 是否关注
      isAttention: false,
      // 防止重复提交
      isRepeatSubmit: false
    }
  },
  computed: {
    isLogin: function() {
      return this.$store.state.token
    }
  },
  components: {
    LeaseList: () => import("@/views/RedesignTeamList/component/LeaseList"), // 出租列表（文字格式）
    Pagination: () => import("@/views/Construction/components/Pagination"), // 分页
    InByLetDialog: () => import("@/components/public/InquiryLetterDialog"), // 函询弹框
    Breadcrumb: () => import("@/components/public/RedesignBreadcrumb"),
    mapdetail: () => import("@/components/public/components/mapDetail"),
    TeamTableList: () => import("./TeamTableList")
  },

  created() {
    const id = this.$route.params.id ? this.$route.params.id : null
    if (id) {
      sessionStorage.save("equNo", id)
      this.TeamInfoDetail(id)
    }
    this.getteamSizeOption()
  },
  mounted() {
    if (cookie.cookieRead("token")) {
      this.userFocus()
    }
  },
  methods: {
    formatDate,
    ChangeString(data) {
      const stringF = data.firstCategoryName ? data.firstCategoryName : ""
      const stringS = data.secondCategoryName
        ? `/${data.secondCategoryName}`
        : ""
      const stringT = data.thirdCategoryName ? `/${data.thirdCategoryName}` : ""
      return `${stringF} ${stringS}${stringT} `
    },
    /** @name 函询按钮点击方法 */
    async inByLetDialogClick() {
      if (this.$store.state.loginType) {
        this.inByLetDialogShow = true
      } else {
        this.loginIndex()
      }
    },
    /** @name 函询取消 */
    cancelDialog(val) {
      this.inByLetDialogShow = val
    },
    /** @name 函询关闭 */
    closeinDialog(val) {
      this.inByLetDialogShow = val
    },
    /** @name 函询提交 */
    async confirminDialog(obj) {
      this.$set(obj, "teamCompamyNo", this.companyNo)
      this.$set(obj, "teamUserNo", this.userNo)
      this.$set(obj, "markName", this.messageData.teamName)
      this.$set(obj, "markType", 1)
      let params = { markId: this.$route.params.id, ...obj }
      let res = await apiResignAll.getSaveForBid(params)
      if (res.data.code === ERR_OK) {
        this.$message.success("提交成功")
        this.inByLetDialogShow = false
      } else {
        this.$message.error("提交失败")
      }
    },
    // 点击查看地图
    showMap() {
      this.dialogFormVisible = true
    },
    ChangeStringRec(data) {
      //
      const array = []
      if (data.businessScopes && data.businessScopes.length > 0) {
        data.businessScopes.map(item => {
          const secArray = []
          if (item.firstCategoryName) {
            secArray.push(item.firstCategoryName)
          }
          if (item.secondCategoryName) {
            secArray.push(item.secondCategoryName)
          }
          if (item.thirdCategoryName) {
            secArray.push(item.thirdCategoryName)
          }
          if (item.fourCategoryName) {
            secArray.push(item.fourCategoryName)
          }
          if (item.fifthCategoryName) {
            secArray.push(item.fifthCategoryName)
          }
          if (item.sixthCategoryName) {
            secArray.push(item.sixthCategoryName)
          }
          array.push(secArray.join("/"))
        })
      }
      //
      return array.join("；")
      // const stringF = data.firstCategoryName ? data.firstCategoryName : "";
      // const stringS = data.secondCategoryName
      //   ? `/${data.secondCategoryName}`
      //   : "";
      // const stringT = data.thirdCategoryName
      //   ? `/${data.thirdCategoryName}`
      //   : "";
      // return `${stringF} ${stringS}${stringT} `;
    },
    /** @name 处理头部主营业务 */
    ChangeStringBus(data) {
      //
      const array = []
      if (data.businessScopes && data.businessScopes.length > 0) {
        data.businessScopes.map(item => {
          const secArray = []
          if (item.firstCategoryName) {
            secArray.push(item.firstCategoryName)
          }
          if (item.secondCategoryName) {
            secArray.push(item.secondCategoryName)
          }
          if (item.thirdCategoryName) {
            secArray.push(item.thirdCategoryName)
          }
          if (item.fourCategoryName) {
            secArray.push(item.fourCategoryName)
          }
          if (item.fifthCategoryName) {
            secArray.push(item.fifthCategoryName)
          }
          if (item.sixthCategoryName) {
            secArray.push(item.sixthCategoryName)
          }
          array.push(secArray.join("/"))
        })
      }
      //
      return array.join("；")
      // const stringF = data.firstCategoryName ? data.firstCategoryName : "";
      // const stringS = data.secondCategoryName
      //   ? `/${data.secondCategoryName}`
      //   : "";
      // const stringT = data.thirdCategoryName
      //   ? `/${data.thirdCategoryName}`
      //   : "";
      // return `${stringF} ${stringS}${stringT} `;
    },
    ChangeStringInfo(data) {
      //
      // const string = data.replace(/\n/g, '<br/>');
      const string = data
      return string
    },
    // 企业网站
    enterpriseWeb() {
      window.open(
        process.env.VUE_APP_MATERIALSURL +
          "/#/company/" +
          this.messageData.companyId,
        "_blank"
      )
    },
    GoDetila(id) {
      this.$router.push({
        path: `/teamDetails/${id}`
      })
      location.reload()
    },
    // 获取视频相册
    async GetfindAlbumByTeamNo(data) {
      let res = await apiResignAll.GetfindAlbumByTeamNo(data)
      //
      //
      //
      this.CertList = res.data.data
      // this.loadingTrue = false;
    },
    // 地址
    ChangeAddress(data) {
      var array = []
      if (data) {
        const objArray = JSON.parse(data) ? JSON.parse(data) : []
        //

        objArray.map(item => {
          array.push(item.name)
        })
      }
      //
      const string = array.join(",")
      return string
    },
    // 报价分页
    offergetPage() {
      this.getTeamOffer(this.offerParam)
    },
    // 设备分页
    equgetTeam() {
      this.teamDetailEquipmentList(this.equParam)
    },

    // 业绩分页
    getTeamperformance() {
      this.getTeamResults(this.performanceParam)
    },
    // 人员分页
    getTeamPersonPage() {
      this.getTeamPerson(this.performanceParamPerson)
    },
    // 获得推荐列表
    async newSettledList(id, no) {
      const obj = {
        id,
        no
      }
      let res = await apiResignAll.recommendList(obj)

      if (res && res.data && res.data.code === 200) {
        this.newSettledListData = res.data.data.slice(0, 3)
      }
    },
    // 查看更多
    More() {
      this.$store.commit("SET_INDEXKEY", 1)
      localStorage.set("indexKey", 1)
      this.$router.push("/teamList")
    },
    // 联系号码
    ShowPhone(phone) {
      if (phone && phone.length === 11) {
        const number = `${phone.slice(0, 3)}****${phone.slice(7, 11)}`
        return number
      }
    },
    // 团队状态

    // 获得团队规模
    async getteamSizeOption() {
      let res = await apiResignAll.getteamSizeOption(2)
      //
      //
      if (res && res.data && res.data.code === 200) {
        this.teamSizeOption = res.data.data
      }
    },
    // 团队规模
    SizeData(data) {
      const obj = this.teamSizeOption.find(
        (value, index, array) => value.no === data
      )
      if (obj) {
        return obj.name
      }
      // switch (Number(data)) {
      //   case 0:
      //     return "-";
      //   case 1:
      //     return "10-30人";
      //     break;
      //   case 2:
      //     return "30-50人";
      //     break;
      //   case 3:
      //     return "50-80人";
      //     break;
      //   case 4:
      //     return "80-100人";
      //     break;
      //   case 5:
      //     return "100人以上";
      //     break;
      //   default:
      //     break;
      // }
    },

    // 获得详情
    async TeamInfoDetail(id) {
      let res = await apiResignAll.TeamInfoDetails(id)
      //

      if (res && res.data && res.data.code === 200) {
        Object.assign(this.messageData, res.data.data)
        // this.messageData.isCompany = 2;
        //
        this.companyNo = this.messageData.companyNo
        this.userNo = this.messageData.userNo
        // this.text.text = this.ChangeAddress(this.messageData.serviceArea)
        this.text.text =
          this.messageData.provinceName +
          (this.messageData.cityName ? "/" + this.messageData.cityName : null)
        let temp = [
          Number(this.messageData.longitude),
          Number(this.messageData.latitude)
        ]
        this.mapCenter = temp
        this.mapPosition.push(Number(temp[0]))
        this.mapPosition.push(Number(temp[1]))

        /** @name 获取工队业绩列表接口参数 */
        if (this.messageData.isCompany === 1) {
          this.performanceParam.companyNo = this.messageData.companyNo
          this.performanceParam.userNo = ""
          this.getTeamResults(this.performanceParam)
        } else {
          this.performanceParam.companyNo = ""
          this.performanceParam.userNo = this.messageData.userNo
          this.getTeamResults(this.performanceParam)
        }

        /** @name 获取工队人员列表接口参数 */
        if (this.messageData.isCompany === 1) {
          this.performanceParamPerson.companyNo = this.messageData.companyNo
          this.performanceParamPerson.userNo = ""
          this.getTeamPerson(this.performanceParamPerson)
        } else {
          this.performanceParamPerson.companyNo = ""
          this.performanceParamPerson.userNo = this.messageData.userNo
          this.getTeamPerson(this.performanceParamPerson)
        }

        /** @name 获取设备信息列表接口参数 */
        if (this.messageData.isCompany === 1) {
          this.equParam.companyNo = this.messageData.companyNo
          this.equParam.userNo = ""
          this.teamDetailEquipmentList(this.equParam)
        } else {
          this.equParam.companyNo = ""
          this.equParam.userNo = this.messageData.userNo
          this.teamDetailEquipmentList(this.equParam)
        }

        /** @name 获取工种报价列表接口参数 */
        if (this.messageData.isCompany === 1) {
          this.offerParam.companyNo = this.messageData.companyNo
          this.offerParam.userNo = ""
          this.getTeamOffer(this.offerParam)
        } else {
          this.offerParam.companyNo = ""
          this.offerParam.userNo = this.messageData.userNo
          this.getTeamOffer(this.offerParam)
        }

        // 团队推荐
        this.newSettledList(this.messageData.provinceNo, id)

        // 获取视频相册
        this.GetfindAlbumByTeamNo(id)

        // if (
        //   this.messageData.equipments &&
        //   this.messageData.equipments.length > 0
        // ) {
        //   this.equTeamList = this.messageData.equipments;
        // } else {
        //   this.equnoTextData = true;
        // }

        // 获得证书
        // this.getCertList();
      }
    },

    /** @name 获取工种报价列表数据 */
    async getTeamOffer(data) {
      let res = await apiResignAll.getTeamteamPrice(data)

      if (res && res.data && res.data.code === 200) {
        this.offerdataList = res.data.data.records
        if (this.offerdataList.length === 0) {
          this.offernoTextData = true
        } else {
          this.offernoTextData = false
        }
        this.$set(this.offerParam, "total", res.data.data.total)
      }
    },
    /** @name 获取工队列表数据 */
    async getTeamResults(data) {
      let res = await apiResignAll.getTeamResults(data)
      //
      //
      if (res && res.data && res.data.code === 200) {
        this.dataList = res.data.data.records
        if (this.dataList.length === 0) {
          this.noTextData = true
        } else {
          this.noTextData = false
        }
        this.$set(this.performanceParam, "total", res.data.data.total)
      }
    },

    /** @name 获取工队人员数据 */
    async getTeamPerson(data) {
      let res = await apiResignAll.getTeamPerson(data)
      if (res.data.code === 200) {
        this.teamPersondataList = res.data.data.records
        if (this.teamPersondataList.length === 0) {
          this.noTextDataPerson = true
        } else {
          this.noTextDataPerson = false
        }
        this.$set(this.performanceParamPerson, "total", res.data.data.total)
      }
    },

    /** @name 获取设备列表数据 */
    async teamDetailEquipmentList(data) {
      let res = await apiResignAll.getequipmentList(data)
      if (res.data.code === 200) {
        this.equTeamList = res.data.data.records
        if (this.equTeamList.length === 0) {
          this.equnoTextData = true
        } else {
          this.equnoTextData = false
        }
        this.$set(this.equParam, "total", res.data.data.total)
      }
    },

    // 获取证书
    async getCertList() {
      let res = await apiResignAll.getCertificateList()
      if (res && res.data && res.data.code === 200) {
        this.CertList = res.data.data.records
        if (this.CertList.length === 0) {
          this.CertnoTextData = true
        } else {
          this.CertnoTextData = false
        }
      }
    },

    /** @name 在线咨询 */
    OnlineConsulting() {
      if (this.$store.state.loginType) {
        if (this.messageData.imId) {
          axios
            .get(
              process.env.VUE_APP_APITEAM +
                "/consultation?id=" +
                this.messageData.imId
            )
            .then(res => {
              if (res.data.code === ERR_OK) {
                this.$store.commit("SET_ISOPEN", true)
                this.$store.commit("SETTOUSER", res.data.data.imAccount)
              } else {
                this.$message.error(res.data.msg)
              }
            })

        } else {
          this.$message.error("未设置客服人员，无法咨询！")
        }
      } else {
        this.loginIndex()
      }
    },
    //  查看联系方式
    ShowPhoneNumber() {
      if (this.$store.state.loginType) {
        this.showpNumber = true
      } else {
        this.loginIndex()
      }
    },
    loginIndex() {
      let data = {
        callBack: function() {
          this.$store.dispatch("setUser")
          this.pushThis()
        }.bind(this)
      }
      this.$_login(data)
    },

    formatDate2,
    computedP() {
      let infobox = document.getElementsByClassName("p_content")
      Array.from(infobox).forEach(element => {
        if (element.offsetHeight < 93) {
          element.nextSibling.style.display = "none"
        } else {
          element.style.height = "96px"
        }
      })
    },
    hasClass(_classList, _className) {
      if (_classList.indexOf(_className) !== -1) {
        return true
      } else {
        return false
      }
    },
    targetOpen(e) {
      const currentTarget = e.currentTarget
      const child = currentTarget.parentNode.children
      const parent = currentTarget.parentNode
      const previous = currentTarget.parentNode.previousSibling
      if (this.hasClass(previous.className, "ellipsis4")) {
        previous.classList.remove("ellipsis4")
        previous.style.height = "auto"
        child[0].innerHTML = "点击收起"
        child[1].classList.remove("el-icon-caret-bottom")
        child[1].classList.add("el-icon-caret-top")
        parent.classList.add("isopen")
      } else {
        previous.classList.add("ellipsis4")
        previous.style.height = "96px"
        child[0].innerHTML = "点击展开"
        child[1].classList.remove("el-icon-caret-top")
        child[1].classList.add("el-icon-caret-bottom")
        parent.classList.remove("isopen")
      }
    },
    tel(telNum) {
      if (telNum) {
        let ary = telNum.split("")
        ary.splice(3, 4, "****")
        return ary.join("")
      }
      return ""
    },
    checkContactway() {
      if (this.$store.state.loginType) {
        this.constructionTeamData.concatPhone = this.phone
      } else {
        link.login()
        //   this.$confirm('当前未登录, 是否跳转到登录页面?', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(() => {
        //     window.location.href = process.env.VUE_APP_DOMAIN +'/login'
        //   })
      }
    },
    async iniData(id) {
      let getData = await apiTalentsMess.getTeamDetail(id)
      this.constructionTeamData = getData.data.data
      this.title.name = this.constructionTeamData.title
      this.title.updateTime = this.constructionTeamData.submitTime
      let typeData = await apiTalentsMess.getTeamType(id)
      this.teamTypeData = typeData.data.data.first
      this.teamSkillsData = typeData.data.data.second
      this.getShowTab()
      // this.$refs.tab.listener();

      this.phone = this.constructionTeamData.concatPhone
      this.constructionTeamData.concatPhone = this.tel(
        this.constructionTeamData.concatPhone
      )
    },
    check(index) {
      this.checkIndex = index
      switch (index) {
        case 0:
          // this.$refs.detailsInner1.toOffset()
          break
        case 1:
          // this.$refs.detailsInner2.toOffset()
          break
        case 2:
          this.getTeamResults(this.performanceParam)
          // this.$refs.detailsInner3.toOffset()
          break
        case 3:
          this.getTeamPerson(this.performanceParamPerson)
          // this.$refs.detailsInner4.toOffset()
          break
        case 4:
          this.teamDetailEquipmentList(this.equParam)
          // this.$refs.detailsInner4.toOffset()
          break
      }
    },
    changeRollScroll(bol) {
      this.rollScroll = bol
    },

    menu() {},
    getShowTab() {},
    // 获取是否关注
    userFocus() {
      let params = {
        no: this.$route.params.id,
        type: 5
      }
      apiHelp.userFocus(params).then(res => {
        if (res.data && res.data.code === 200) {
          this.isAttention = res.data.data
        }
      })
    },

    // 点击关注
    clickAttention(state) {
      let token = this.$store.state.token
      if (!token) {
        let data = {
          callBack: function() {
            this.$store.dispatch("setUser")
          }.bind(this)
        }
        this.$_login(data)
      } else {
        let params = {
          businessNo: this.$route.params.id,
          type: 5
        }
        if (this.isRepeatSubmit) return
        this.isRepeatSubmit = true
        apiHelp
          .attentionHandle(params)
          .then(res => {
            if (res.data && res.data.code === 200) {
              this.isAttention = state
              if (state) {
                this.$message.success("关注成功")
              } else {
                this.$message.success("取消关注成功")
              }
            }
          })
          .finally(() => {
            this.isRepeatSubmit = false
          })
      }
    }
  },
  watch: {
    isLogin: {
      handler: function(newVal, oldVal) {
        newVal && this.userFocus()
      }
    },
    CertList(n, o) {
      if (n && n.length > 0) {
        n.map(idx => {
          if (idx.type === 1) {
            // 图片
            const array = []
            array.push(idx.url)
            idx.picturePicData = array
          } else if (idx.type === 2) {
            // 视频
            idx.pictureVideoData = idx.url
          }
        })
        //
      }
    },
    equTeamList(n, o) {
      //
      n.map(item => {
        //
        if (typeof item.picture === "string") {
          item.picture = item.picture.split(",")
        }
      })
    },
    "messageData.teamIntroduce": {
      handler() {
        this.$nextTick(function() {
          let sort = window.getComputedStyle(this.$refs.textShow).height
          let height = sort.slice(0, -2)
          if (Number(height) >= 115) {
            this.isHtml = true
          } else {
            this.isHtml = false
          }
        })
      },
      deep: true
    },
    checkIndex: {
      handler(newValue) {
        //
        if (newValue === 1) {
          this.$nextTick(function() {
            let sort = window.getComputedStyle(this.$refs.textShow).height
            let height = sort.slice(0, -2)
            // if (Number(height) >= 115) {
            if (Number(height) >= 115) {
              this.isHtml = true
            } else {
              this.isHtml = false
            }
          })
        }
      },
      deep: true
    }
  },

  destroyed() {
    // window.removeEventListener("scroll", this.menu);
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/variable.scss";

.bgdf {
  background: #dfe4ea;
}

.talents {
  width: 100%;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: flex-start;

  &_details {
    width: 1200px;
    background: #f5f5f5;

    &_content {
      width: 1200px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;

      &_left {
        width: 1200px;

        &_titleBox {
          width: 1200px;
          margin: 0 auto 20px;
          box-sizing: border-box;
          background-color: #ffffff;
          padding: 20px 30px;
          // box-shadow: 0 2px 5px #e1e1e1;
          border-radius: 3px;
          position: relative;
          border-bottom: 1px solid #e4e7ed;
          display: flex;
          .left_box {
            flex: 1;
          }
          .right_box {
            flex: 1;
            .attention-wrap {
              flex: 1;
              display: flex;
              flex-direction: column;
              font-size: 14px;
              color: #666666;
              text-align: right;

              .attention-item {
                margin-right: 30px;
                cursor: pointer;

                img {
                  margin-right: 10px;
                  position: relative;
                  top: 2px;
                }
              }
            }
            .imgIcon {
              flex: 5;
              text-align: right;
              line-height: 60px;
              img {
                display: inline-block;
                // width: 10px;
                // height: 10px;
                // border: 1px solid #999;
                margin-right: 15px;
              }
            }
            .isgeti {
              display: flex;
              justify-content: flex-end;
              .Inquirys {
                border: 1px solid #0099ff;
                border-radius: 5px;
                font-size: 14px;
                color: #0099ff;
                width: 40px;
                text-align: center;
                height: 30px;
                line-height: 30px;
                cursor: pointer;
                margin-right: 10px;
              }
              .zixun {
                border: 1px solid #0099ff;
                color: #0099ff;
                width: 90px;
                font-size: 14px;
                padding: 0px 5px;
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
              }
            }
            .footer {
              display: flex;
              justify-content: space-between;
              align-items: center;
              line-height: 30px;

              .textLeft {
                cursor: pointer;
                background: #0099ff;
                color: white;
                width: 80px;
                font-size: 14px;
                // text-align: center;
                padding: 0px 5px;
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 15px auto;
                margin: 15px 10px 15px auto;
              }
              .Inquiry {
                border: 1px solid #0099ff;
                border-radius: 5px;
                font-size: 14px;
                color: #0099ff;
                width: 40px;
                text-align: center;
                height: 30px;
                line-height: 30px;
                cursor: pointer;
              }

              .box {
                // margin: 10px 0 20px;
                border: 1px solid #0099ff;
                color: #0099ff;
                width: 90px;
                font-size: 14px;
                // text-align: center;
                padding: 0px 5px;
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 15px auto;
                margin: 15px 0px auto 10px;

                img {
                  margin-right: 5px;
                }

                cursor: pointer;
              }
            }
          }

          .title-icon {
            width: 240px;
            > span {
              background: #0286df;
              border-radius: 4px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: white;
              line-height: 21px;
              margin-left: 20px;
              padding: 0px 6px;
            }
          }

          .mark {
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: rgba(255, 255, 255, 1);
            color: white;
            position: absolute;
            left: -20px;
            top: 8px;
            height: 0;
            width: 36px;
            line-height: 24px;
            border-bottom: 25px solid #409ee9;
            border-left: 25px solid transparent;
            border-right: 25px solid transparent;
            transform: rotate(-45deg);
          }

          .unmark {
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 300;
            color: rgba(255, 255, 255, 1);
            color: white;
            position: absolute;
            left: -20px;
            top: 8px;
            height: 0;
            width: 36px;
            line-height: 24px;
            border-bottom: 25px solid #969696;
            border-left: 25px solid transparent;
            border-right: 25px solid transparent;
            transform: rotate(-45deg);
          }

          .title {
            margin-bottom: 10px;
            display: flex;
            align-items: flex-start;

            .text {
              font-size: 24px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(0, 0, 0, 1);
              line-height: 36px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              max-width: 800px;
              -webkit-box-orient: vertical;
            }

            .show {
              width: 100px;
              width: 140px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(150, 150, 150, 1);
              line-height: 30px;
            }

            .icon {
              border-radius: 5px;
              display: inline-block;
              padding: 10px 20px;
              background: #0099ff;
              color: white;
              padding: 5px 9px;
              font-size: 14px;
              margin-left: 15px;
            }
          }

          .item {
            font-size: 14px;
            display: flex;
            // justify-content: space-between;
            align-items: flex-start;
            line-height: 30px;
            .flex-item {
              display: flex;
              flex: 1;
              // > div {
              //   &:nth-child(1) {
              //     flex: 1;
              //   }
              //   // &:nth-child(2) {
              //   //   width: 900px;
              //   // }
              // }
            }
            span.showText {
              color: #0099ff;
              margin-left: 14px;
              text-decoration: underline;
              cursor: pointer;
            }
            & > div {
              margin-right: 20px;

              span {
                color: #666;

                &:nth-child(2) {
                  color: #333;
                }
              }
            }
          }

          .itemBottom {
            font-size: 14px;
            display: flex;
            align-items: flex-start;
            line-height: 30px;

            > div {
              // width: 600px;
              // text-overflow: -o-ellipsis-lastline;
              // overflow: hidden;
              // text-overflow: ellipsis;
              // display: -webkit-box;
              // -webkit-line-clamp: 2;
              // -webkit-box-orient: vertical;
              &:nth-child(1) {
                margin-right: 20px;
              }
              span {
                color: #666;

                &:nth-child(2) {
                  color: #333;
                }
              }
            }
          }
        }

        .tab-box {
          width: 1200px;
          margin: 0 auto;

          .inner {
            background: #f5f5f5;

            > div {
              background: white;
              display: inline-block;
              width: 105px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              font-size: 14px;
              border: 1px solid rgba(228, 231, 237, 1);
            }

            .check {
              // background: #fff;
              color: $default;
              position: relative;
              // &::before {
              //   content: "";
              //   display: block;
              //   position: absolute;
              //   top: -1px;
              //   left: 0;
              //   width: 100%;
              //   border-top: 2px solid $default;
              // }
              &::after {
                content: "";
                display: block;
                position: absolute;
                bottom: -1px;
                left: 0;
                width: 100%;
                border-top: 1px solid #fff;
              }
            }
          }
        }

        .details-inner-box {
          width: 1200px;
          // margin: 0 auto 50px;
          box-sizing: border-box;
          background-color: white;
          // box-shadow: 3px 3px 10px rgba($color: #000000, $alpha: 0.08);
          border-radius: 0 0 4px 4px;
          border-left: 1px solid rgba(228, 231, 237, 1);

          .p_info {
            color: #666;
            font-size: 14px;
            padding: 20px;
            // padding-bottom: 0;
            width: 1160px;

            .p_content {
              line-height: 24px;
              margin: 19px 0;
            }

            .target {
              cursor: pointer;
              color: #0286df;
              margin-bottom: 16px;
            }

            .isopen {
              color: #ff6600;
            }
          }

          .Sale {
            min-height: 400px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 23px;
            margin-bottom: 30px;
          }

          .Induce {
            min-height: 400px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 23px;

            .text {
              margin-bottom: 30px;
              display: -webkit-box;
              overflow: hidden;
              -webkit-line-clamp: 5;
              -webkit-box-orient: vertical;
            }

            .actionShow {
              display: -webkit-box;
              overflow: hidden;
              -webkit-line-clamp: 100;
              -webkit-box-orient: vertical;
            }

            .optionShow {
              //  margin-bottom: 30px;
              .showUp {
                color: #0286df;
                cursor: pointer;
              }

              .showDown {
                color: #ff6600;
                cursor: pointer;
              }
            }
          }

          .p_img {
            padding: 20px 0 0;
            clear: both;
            overflow: hidden;

            .imgs {
              float: left;
              width: 214px;
              height: 133px;
              margin-right: 21px;
              margin-bottom: 20px;

              &:nth-child(5n + 5) {
                margin-right: 0;
              }

              img {
                display: block;
                width: 100%;
                height: 100%;
              }
            }
          }

          .ellipsis4 {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
          }

          .itemListCert {
            padding: 0 20px;

            .itemList {
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              flex-wrap: wrap;

              .item {
                // width: 165px;
                // height: 100px;
                border: 1px solid #f0f0f0;
                margin: 0 19px 20px 0;
                cursor: pointer;

                .imgBox {
                  width: 216px;
                  height: 140px;
                  position: relative;

                  img {
                    width: 216px;
                    height: 122px;
                  }

                  .imgFooter {
                    visibility: hidden;

                    width: 196px;
                    height: 34px;
                    position: absolute;
                    left: 0;
                    bottom: 0px;
                    display: flex;
                    justify-content: space-between;
                    justify-content: center;
                    align-items: center;
                    background: rgba(0, 0, 0, 1);
                    opacity: 0.5;
                    padding: 0 10px;
                    border-bottom: 1px solid rgba(228, 231, 237, 1);

                    .editor {
                      font-size: 14px;
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      color: rgba(2, 134, 223, 1);
                      line-height: 24px;
                      cursor: pointer;
                      display: flex;
                      justify-content: center;
                      align-items: center;

                      img {
                        display: inline-block;
                        width: 14px;
                        height: 14px;
                        margin: 0 5px 0 20px;
                      }
                    }

                    .dele {
                      font-size: 14px;
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      color: rgba(255, 102, 0, 1);
                      line-height: 24px;
                      cursor: pointer;
                      display: flex;
                      justify-content: center;
                      align-items: center;

                      img {
                        display: inline-block;
                        width: 11px;
                        height: 14px;
                        margin: 0 5px 0 0px;
                      }

                      span {
                        margin-right: 20px;
                      }
                    }
                  }

                  .isShowFooter {
                    visibility: visible;
                  }
                }

                .imgBoxVideo {
                  width: 214px;
                  height: 133px;
                  position: relative;

                  video {
                    width: 214px;
                    height: 133px;
                  }

                  .imgFooter {
                    visibility: hidden;

                    width: 450px;
                    height: 34px;
                    position: absolute;
                    left: 0;
                    bottom: 0px;
                    display: flex;
                    justify-content: space-between;
                    justify-content: center;
                    align-items: center;
                    background: rgba(0, 0, 0, 1);
                    opacity: 0.5;
                    padding: 0 10px;
                    border-bottom: 1px solid rgba(228, 231, 237, 1);

                    .editor {
                      font-size: 14px;
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      color: rgba(2, 134, 223, 1);
                      line-height: 24px;
                      cursor: pointer;
                      display: flex;
                      justify-content: center;
                      align-items: center;

                      img {
                        display: inline-block;
                        width: 14px;
                        height: 14px;
                        margin: 0 5px 0 20px;
                      }
                    }

                    .dele {
                      font-size: 14px;
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      color: rgba(255, 102, 0, 1);
                      line-height: 24px;
                      cursor: pointer;
                      display: flex;
                      justify-content: center;
                      align-items: center;

                      img {
                        display: inline-block;
                        width: 11px;
                        height: 14px;
                        margin: 0 5px 0 0px;
                      }

                      span {
                        margin-right: 20px;
                      }
                    }
                  }

                  .isShowFooter {
                    visibility: visible;
                  }
                }

                .title {
                  padding: 0 10px;
                  width: 196px;
                  height: 30px;
                  position: relative;
                  font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: rgba(51, 51, 51, 1);
                  line-height: 24px;
                  display: flex;
                  align-items: center;
                }
              }

              .NoData {
                display: none;
              }

              .isShow {
                display: block;
              }
            }
          }
        }
      }

      &_right {
        width: 300px;
        margin-left: 20px;

        .PersonMessage {
          padding: 10px 20px;
          background: white;
          box-shadow: 0 2px 5px #e1e1e1;
          border-bottom: 1px solid #e4e7ed;
          margin-bottom: 10px;

          .name {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            line-height: 36px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .describe {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }

            .text {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }

            .icon {
              display: inline-block;
              background: rgba(2, 134, 223, 1);
              border-radius: 4px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 21px;
              margin-left: 20px;
              padding: 0px 6px;
            }
          }

          .item {
            font-size: 14px;
            line-height: 30px;

            span.showText {
              color: #0099ff;
              margin-left: 14px;
              text-decoration: underline;
              cursor: pointer;
            }
          }

          .box {
            // margin: 10px 0 20px;
            border: 1px solid #0099ff;
            color: #0099ff;
            width: 80px;
            font-size: 14px;
            // text-align: center;
            padding: 8px 15px;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 15px auto;

            img {
              margin-right: 5px;
            }

            cursor: pointer;
          }
        }

        .EnterpriseMessage {
          padding: 10px 20px;
          background: white;
          box-shadow: 0 2px 5px #e1e1e1;
          border-bottom: 1px solid #e4e7ed;
          margin-bottom: 10px;

          .name {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            line-height: 36px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .describe {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }

            .text {
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
            }

            .icon {
              display: inline-block;
              background: rgba(2, 134, 223, 1);
              border-radius: 4px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 21px;
              margin-left: 20px;
              padding: 0px 6px;
            }
          }

          .imgIcon {
            img {
              display: inline-block;
              // width: 10px;
              // height: 10px;
              // border: 1px solid #999;
              margin-right: 15px;
            }
          }

          .item {
            font-size: 12px;
            line-height: 30px;

            span.showText {
              color: #0099ff;
              margin-left: 14px;
              text-decoration: underline;
              cursor: pointer;
            }
          }

          .footer {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .textLeft {
              cursor: pointer;
              background: #0099ff;
              color: white;
              width: 80px;
              font-size: 14px;
              // text-align: center;
              padding: 5px 5px;
              border-radius: 5px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 15px auto;
              margin: 15px 10px 15px auto;
            }

            .box {
              // margin: 10px 0 20px;
              border: 1px solid #0099ff;
              color: #0099ff;
              width: 80px;
              font-size: 14px;
              // text-align: center;
              padding: 5px 5px;
              border-radius: 5px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 15px auto;
              margin: 15px 15px auto 10px;

              img {
                margin-right: 5px;
              }

              cursor: pointer;
            }
          }
        }

        .ImgContent {
          width: 300px;
          height: 100px;
          // margin: 10px 0;
          margin-bottom: 10px;
          border: 1px solid #ccc;
        }
      }
    }
    .dataList {
      padding: 20px;
      background: white;
      margin: 30px 0px;

      > .title {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .name {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(2, 134, 223, 1);
          line-height: 30px;
          border-left: 3px solid #0286df;
          padding-left: 10px;
        }

        .more {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 36px;
          cursor: pointer;
        }
      }

      .itemList {
        padding: 10px 0px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;

        .item {
          width: 273px;
          margin-right: 20px;
          border: 1px solid rgba(228, 230, 237, 1);
          font-size: 12px;
          color: #999;
          line-height: 30px;
          margin-bottom: 20px;
          &:nth-child(4n) {
            margin-right: 0px;
          }

          .top {
            padding: 10px 8px;
            // height: 90px;
            max-height: 90px;
            background: rgba(245, 247, 250, 1);

            .title {
              color: #000;
              font-size: 14px;
              font-weight: 300;
              cursor: pointer;

              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }

          .bottom {
            padding: 10px 8px 0 8px;
            height: 90px;
            height: 70px;

            .type {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .business {
              line-height: 30px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          span {
            color: #333;
          }
        }
      }

      .noList {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 275px;
      }

      // .more {
      //   font-size: 12px;
      //   color: #999;
      //   text-align: right;
      //   margin: 10px 20px 30px;
      //   cursor: pointer;
      // }
    }
  }
}

.noData {
  width: 100%;
  background: #ffffff;
  padding-bottom: 40px;
  padding-top: 50px;
  border-radius: 0 0 4px 4px;
  border-top: none;
  box-sizing: border-box;

  .noDataImg {
    width: 177px;
    margin: 0 auto 15px;

    img {
      width: 100%;
    }
  }

  .noText {
    text-align: center;
    font-size: 18px;
    color: #333;
  }
}
</style>
<style lang="scss" rel="stylesheet/scss">
.changeTootip {
  border: 1px solid #767676 !important;
  padding: 4px !important;
  font-size: 12px !important;
  font-family: Microsoft YaHei;
  // font-weight: 300 !important;
  color: rgba(102, 102, 102, 1) !important;
  border-radius: 2px !important;
  max-width: 1200px !important;
}
</style>
